import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Trip } from 'src/app/Models/MisViajes/Trip';

@Component({
  selector: 'app-lista-viajes',
  templateUrl: './lista-viajes.component.html',
  styleUrls: ['./lista-viajes.component.css']
})
export class ListaViajesComponent implements OnInit {

  @Input()
  trips: Array<Trip>;

  @Output()
  selectedRoute = new EventEmitter<Trip>();

  @Input()
  selectedTrip: Trip;
  constructor() { }

  ngOnInit(): void{
    this.onSelectRoute(this.trips[0]);
  }
  onSelectRoute(trip: Trip): void{
    this.selectedRoute.emit(trip);
  }
}
